import { render, staticRenderFns } from "./rcpx.vue?vue&type=template&id=b869fe0c&scoped=true&"
import script from "./rcpx.vue?vue&type=script&lang=js&"
export * from "./rcpx.vue?vue&type=script&lang=js&"
import style0 from "./rcpx.vue?vue&type=style&index=0&id=b869fe0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b869fe0c",
  null
  
)

export default component.exports